import * as React from "react";
import DialogProps from "./IProps";
import { bindActionCreators } from "redux";
import "../../../assets/sass/widgets/dialog.scss";
import { connect } from "react-redux";
import * as dynamicFormActionCreators from "../../components/DynamicForm/actionCreators";
import { handleEnter, imagePathurl } from "../../utils/utils";
import Loader from "../Loader";
// eslint-disable-next-line @typescript-eslint/no-var-requires
const Loadable = require("react-loadable");

const BSTable = Loadable({
    loader: () => import("../BSTable"),
    loading() {
        return <div>Loading...</div>;
    },
});

/**
 * @class ReviewErrorsPopup
 * @description
 * This component acts as a dialog box to show modal popups with a confirmation button.
 * @category Widgets
 */

const tableColumns = [
    { dataField: "field", headerClasses: "bs-table-header-cell", text: "Field Name" },
    { dataField: "section", headerClasses: "bs-table-header-cell", text: "Section" },
    { dataField: "page", headerClasses: "bs-table-header-cell", text: "Page" },
];

const varianceWaiverStatusEnum = {
    PENDING: 1,
    APPROVED: 2,
    DENIED: 3
}
class ReviewErrorsPopup extends React.Component<DialogProps, any> {
    constructor(props) {
        super(props);
        this.state = {
            checked: false,
            varianceTxtVal: '',
            shouldDisableBtn: true,
            isCheckedForErrors: false,
            isContinueBtnClicked: false,
            isAPIResponseVerified: false,
            isSessionStorageValueChecked: false,
            isSessionStorageValueFetched: false,
            description: "",
            accessoriesErrorArray: [],
            errorsWithoutAccessories: [],
            emailErrorArray: [],
            withoutAllowedErrorsArray: [],
            isVarianceDatafilled: false,
            erorrMsgForEmail: "",
        };
    }
    componentDidMount(): void {
        this.setState({
            isSessionStorageValueChecked: false,
            isAPIResponseVerified: false
        });
        // Clearing state value if exists
        this.props.dynamicFormActions.clearWarrantyVarianceData();
    }
    componentDidUpdate(prevProps: Readonly<DialogProps>, prevState: Readonly<any>, snapshot?: any): void {
        const { isSavingVariance, saveVariance, varianceData, isSavedDraft, variance, errorDetails } = this.props;
        const { errors } = this.props;
        const errorsWithoutAccessories = errors && errors.filter((item) => (item.section !== 'Accessories'));
        const accessoriesErrorArray = errors && errors.filter((item) => item.section === 'Accessories');
        const emailErrorArray = errors && errors.filter((item) => (item.section === "Owner Info" && item.field === "Email"));
        const withoutAllowedErrorsArray = errors && errors.filter((item) => !((item.section === 'Accessories') || (item.section === "Owner Info" && item.field === "Email")));
        let erorrMsgForEmail;
        // Filtering Email Error from ErrorDetails Object
        if (emailErrorArray) {
                const emailErrorMessageFilter = errorDetails && Object.keys(errorDetails)
                                            .filter(key => key.includes("buildingAndOwnerInfo_ownerInfo_contactPerson_email"))
                                            .reduce((obj, key) => {
                                                obj[key] = errorDetails[key];
                                                return obj;
                                            }, {});
                // Get the key dynamically
                const key = Object.keys(emailErrorMessageFilter)[0];
                // Access the array value using the key
                const EmailMessagesArray = emailErrorMessageFilter[key];
                erorrMsgForEmail = EmailMessagesArray && EmailMessagesArray[0] || "";
        }

        let description = window.sessionStorage.getItem('description');
        const requiredCount = window.sessionStorage.getItem('requiredCount');

        // Showing Variance total accessories required message
        if (!this.state.isSessionStorageValueChecked && description && requiredCount && (accessoriesErrorArray.length > 0  || emailErrorArray.length > 0)) {
            description = description.replace("{requiredCount}", requiredCount)
            this.setState({
                isSessionStorageValueChecked: true,
                description,
                accessoriesErrorArray,
                errorsWithoutAccessories,
                emailErrorArray,
                withoutAllowedErrorsArray,
                erorrMsgForEmail,
            })
        }
        // Closing modal on Save variance success, storing value in session storage to use on Utils.ts
        if (!this.state.isAPIResponseVerified && this.state.isContinueBtnClicked && !isSavingVariance && saveVariance && saveVariance.hasOwnProperty("data")) {
            if (saveVariance.data.success === true) {
                sessionStorage.setItem('isVarianceRequested', JSON.stringify(true))
                // Closing the Review Error Modal
                this.props.hidePopsUp();
                // Clearing state value if exists for making API call if exists
                this.props.dynamicFormActions.clearWarrantyVarianceData();
            }
            this.setState({
                isAPIResponseVerified: true,
            });
        }
        // Used setTimeout to fetch sessionStorage value if its null on initial page laod
        if (!this.state.isSessionStorageValueFetched && accessoriesErrorArray.length > 0) {
            setTimeout(() => {
                this.setState({
                    isSessionStorageValueChecked: false,
                })
            }, 1000)
            this.setState({
                isSessionStorageValueFetched: true,
            })
        }
        
        // Re-populating Variance data in modal if already variance exists
        if (!this.state.isVarianceDatafilled && this.state.isSessionStorageValueChecked ) {
             if (variance && variance.isVarianceWaiverRequest) {
                this.setState({
                    checked: true,
                    varianceTxtVal: variance.varianceWaiverComments,
                    shouldDisableBtn: false,
                })
            }
            this.setState({
                isVarianceDatafilled: true
            })
        }
    }

    handleCLick = (e) => {
        this.setState({
            checked: !this.state.checked,
            varianceTxtVal: '',
        }, () => {
            if (this.state.checked) {
                const element = (document.getElementById('varianceTextArea')) as HTMLTextAreaElement;
                if (element) {
                    element.focus()
                }
            }
        });

    };

    continueAsAdminBtnClick = () => {
        // Closing the Review Error Modal
        this.props.hidePopsUp();
        // Clearing state value if exists
        this.props.dynamicFormActions.clearWarrantyVarianceData();
        //  Stroing in sessionStorage to check on Utils to override errors
        sessionStorage.setItem('continueAsAdminForError', JSON.stringify(true));
    }

    txtAreaChange = (e) => {
        this.setState({
            varianceTxtVal: e.target.value,
            shouldDisableBtn: false,
        });
        if (e.target.value.trim() === "") {
            this.setState({
                shouldDisableBtn: true,
            })
        }
    }

    onVarianceContinueClick = () => {
        const { varianceTxtVal, checked } = this.state;
        const { warrantyId } = this.props;
        // Clearing state value if exists
        this.props.dynamicFormActions.clearWarrantyVarianceData();

        if (varianceTxtVal.trim() === "") {
            alert('Please provide the need for Technical Variance')
        } else {
            this.setState({
                isContinueBtnClicked: true,
                isAPIResponseVerified: false,
            })
            const requestPayload = {
                isVarianceWaiverRequest: checked,
                varianceWaiverComments: varianceTxtVal.trim(),
                varianceWaiverStatus: varianceWaiverStatusEnum["PENDING"],
            }
            this.props.dynamicFormActions.saveWarrantyVariance(requestPayload, warrantyId)
        }
    }

    closePoUp = () => {
        this.setState({
            varianceTxtVal: '',
            shouldDisableBtn: true,
            checked: false,
            isSessionStorageValueChecked: false,
        });
        this.props.hidePopsUp();

    }

    goToErrors = () => {
        this.props.goToErrors();

    }

    // Function to evaluate Variance Checkbox display, based on UserRole and Type of Error
    // Displaying Variance to non admin user, only if email filed is entered and no email expression error
    shouldShowVariance = (accessoriesErrorArray, withoutAllowedErrorsArray, isEmailExpressionError, isAdmin, emailErrorArray) => {
        // Must be true for all users
        const hasAccessoriesError = accessoriesErrorArray.length > 0;
        const noAllowedErrors = withoutAllowedErrorsArray.length === 0;
        
        const hasNoEmailErrors = emailErrorArray.length === 0;
        const hasEmailExpressionError = isEmailExpressionError;

        if (isAdmin) {
            const hasOnlyAccessoriesErrors = hasAccessoriesError && noAllowedErrors && !hasEmailExpressionError;

            // Admin-specific
            const showForNoEmailWithAccessories = hasAccessoriesError && hasNoEmailErrors;
            const showForOnlyAccessories = hasOnlyAccessoriesErrors;

            return showForNoEmailWithAccessories || showForOnlyAccessories;
        } else {
            // Contractor-specific
            const showForNoErrors = hasAccessoriesError && hasNoEmailErrors && noAllowedErrors;

            return !hasEmailExpressionError && showForNoErrors;
        }
    };

    render() {
        const { errors } = this.props;
        const checkBoxVal = this.state.checked;
        const isSavingVariance = this.props.isSavingVariance;
        const { description, accessoriesErrorArray, errorsWithoutAccessories, emailErrorArray, withoutAllowedErrorsArray, erorrMsgForEmail } = this.state;
        const isAdmin = this.props.userInfo.isAdmin
        const isEmailExpressionError = erorrMsgForEmail && erorrMsgForEmail.includes("valid e-mail") ? true : false;
        const showVariance = this.shouldShowVariance(accessoriesErrorArray, withoutAllowedErrorsArray, isEmailExpressionError, isAdmin,emailErrorArray)
        const getimagePath = imagePathurl();
        return (
            <React.Fragment>
                {isSavingVariance ? <Loader /> : null}
                <div className="modal-container review-errors" id="model-container-id">
                    <div className="overlay">
                        <div className="popup-container">
                            <div className="close-menu" onClick={() => this.closePoUp()}>
                                <img
                                    onKeyPress={handleEnter}
                                    className="popup-close-icon"
                                    src={`${getimagePath}close-mobile.png`}
                                    alt="close"
                                />
                            </div>
                            <div className="review-error-modal-body">
                                <div className="popup-header-title">Review Errors</div>
                                <div className="popup-header-subtitle">
                                    {`The following errors require your attention before proceeding to the Review & Pay page`}
                                </div>
                                <div className="popup-body">
                                    {this.props.screenResolution.width >= 768 && (
                                        <BSTable
                                            striped
                                            bordered={false}
                                            tableColumnData={tableColumns}
                                            tableRowData={errors}
                                            tableRowClick={() => { }}
                                            tableRowDelete={() => { }}
                                        />
                                    )}
                                    {this.props.screenResolution.width < 768 && (
                                        <div>
                                            <div className="item-list">
                                                {errors.map((error, index) => {
                                                    return (
                                                        <div
                                                            key={`error-item${index}`}
                                                            className={`item d-flex menu-item table-row-id-${index}`}
                                                        >
                                                            <div className="flex-coloumn w-100">
                                                                <div className="field-name">{error.field}</div>
                                                                <div className="section-name">{error.section}</div>
                                                                <div className="page-detail">{error.page}</div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="text-center">
                                    <button
                                        className="popup-btn"
                                        type="button"
                                        onClick={this.props.goToErrors}
                                        onKeyPress={handleEnter}
                                    >
                                        Go To Errors
                                    </button>
                                    {(isAdmin && (
                                        ((accessoriesErrorArray.length > 0 || emailErrorArray.length > 0) && !isEmailExpressionError && withoutAllowedErrorsArray.length === 0)
                                    )) && (
                                          <button
                                          className="popup-btn continue-admin-btn"
                                          type="button"
                                          onClick={() => this.continueAsAdminBtnClick()}
                                        //   onKeyPress={handleEnter}
                                      >
                                          Continue As Admin
                                      </button>
                                    )}
                                </div>
                                {/* {isEmailExpressionError && (
                                    <p className="error-message">
                                        {erorrMsgForEmail}
                                    </p>
                                )} */}
                                {
                                // (accessoriesErrorArray.length > 0 && withoutAllowedErrorsArray.length === 0 && !isEmailExpressionError 
                                //  && ((!isAdmin && emailErrorArray.length === 0) || isAdmin )
                                // ) 
                                    showVariance
                                    && (
                                    <div className="variance-err-message-div">
                                        <div>
                                            <p className="error-message">
                                                {`${description} or request a Technical Variance.`}
                                            </p>
                                        </div>
                                        <div>
                                            <div className="header-div-variance">
                                                <p className="popup-header-title">Variance waiver request: </p>
                                                <div className="checkbox-container-div">
                                                    <label className={`variance-checkbox ${checkBoxVal ? "checked" : "unchecked"}`} htmlFor="checkboxVariance">
                                                        <input
                                                            checked={this.state.checked}
                                                            type="checkbox"
                                                            className="hide-checkbox"
                                                            onClick={this.handleCLick}
                                                            id='checkboxVariance'
                                                        />
                                                    </label>
                                                    <div className="checkbox-label"> Request approval for a Technical Variance</div>
                                                </div>
                                            </div>

                                            {this.state.checked && (
                                                <div className="variance-textarea-div">
                                                    <div className="textarea-container">
                                                        <p>Please explain the need for the Technical Variance:</p>
                                                        <textarea
                                                            id="varianceTextArea"
                                                            className='variance-textarea'
                                                            value={this.state.varianceTxtVal}
                                                            name='varianceTxtVal'
                                                            onChange={(e) => this.txtAreaChange(e)}
                                                            maxLength={500}
                                                            rows={2}
                                                        />
                                                    </div>
                                                    <div className="variance-btn-div">
                                                        <button
                                                            className="popup-btn"
                                                            disabled={this.state.shouldDisableBtn}
                                                            onClick={() => this.onVarianceContinueClick()}
                                                        >
                                                            Continue
                                                        </button>
                                                    </div>

                                                </div>
                                            )}

                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export function mapStateToProps(state) {
    return {
        screenResolution: state.globalInfo.screenResolution,
        warrantyId: state.dynamicFormInfo.warrantyId,
        isSavingVariance: state.dynamicFormInfo.isSavingVariance,
        saveVariance: state.dynamicFormInfo.saveVariance,
        varianceData: state.dynamicFormInfo.layoutResponse.variance,
        variance: state.dynamicFormInfo.variance,
        isSavedDraft: state.dynamicFormInfo.layoutResponse.isSavedDraft,
        userInfo: state.adminData.userInfo,
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        dynamicFormActions: bindActionCreators(dynamicFormActionCreators, dispatch),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ReviewErrorsPopup);
